<template>
  <ViewWrapper class="timeout-overview">
    <RadarChart class="timeout-overview__chart" />
    <div class="timeout-overview__content">
      <h4 class="timeout-overview__headline">{{ $t('view.timeoutOverview.headline') }}</h4>
      <p class="timeout-overview__paragraph">
        {{ $t('view.timeoutOverview.copy') }}
      </p>
      <ButtonPill class="timeout-overview__continue-button" :to="{ name: 'home' }" replace>
        {{ $t('game.playAgain') }}
      </ButtonPill>
    </div>
  </ViewWrapper>
</template>

<script>
import { playSound } from '../services/sound';

import ButtonPill from '../components/ButtonPill';
import ViewWrapper from '../components/ViewWrapper';
import RadarChart from '../components/radarChart/RadarChart';

export default {
  name: 'SectionOverview',

  components: {
    ButtonPill,
    RadarChart,
    ViewWrapper,
  },

  mounted() {
    playSound('fxA', 'headline');
  },
};
</script>

<style lang="scss" scoped>
.timeout-overview {
  position: relative;
  background-color: rgba($color: $color-black, $alpha: $view-overlay-alpha);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.timeout-overview__chart {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.2;
  margin-bottom: 60px;
}

.timeout-overview__content {
  text-align: center;
  p {
    margin-bottom: 40px;
  }
}

.timeout-overview__slide {
  text-align: center;
}

.timeout-overview__continue-button {
  margin-top: 20px;
  bottom: calc(20px + env(safe-area-inset-bottom));
  margin-left: auto;
  margin-right: auto;
  max-width: 180px;
}
</style>
